import { SliderDemos, SwitchDemos, PasswordInputDemos, FormDemos, SelectDemos } from '@mantine/demos';
import * as React from 'react';
export default {
  SliderDemos,
  SwitchDemos,
  PasswordInputDemos,
  FormDemos,
  SelectDemos,
  React
};